// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_db-2";
export var aiChatCartContainerExit = "_db-4";
export var aiChatContainerLarge = "_db-0";
export var aiChatContainerSmall = "_db-1";
export var aiChatIcon = "_db-6";
export var slideInFromRight = "_db-3";
export var slideOutToRight = "_db-5";